"use strict";

var _regeneratorRuntime = require("/Users/jonathanallenberg/projects/boxtronik/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/regenerator");

require("regenerator-runtime/runtime");

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.marshalPrivateKey = exports.unmarshalPrivateKey = exports.marshalPublicKey = exports.unmarshalPublicKey = exports.generateKeyPair = exports.supportedKeys = exports.keyTypeError = void 0;

var ed25519 = __importStar(require("./ed25519"));

var proto_keys_1 = require("./proto.keys");
/**
 * Exposes an interface to various cryptographic key generation routines.
 * Currently the 'ed25519' types are supported, although ed25519 keys
 * support only signing and verification of messages.
 */


exports.keyTypeError = new Error("Unsupported key type.");
exports.supportedKeys = {
  ed25519: ed25519
}; // Generates a keypair of the given type and bitsize

exports.generateKeyPair = function (type, bytesLength) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!(type !== "Ed25519")) {
              _context.next = 2;
              break;
            }

            throw exports.keyTypeError;

          case 2:
            return _context.abrupt("return", ed25519.generateKeyPair(bytesLength));

          case 3:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
};
/**
 * Converts a protobuf serialized public key into its representative object
 * @param buf The input key bytes.
 */


exports.unmarshalPublicKey = function (buf) {
  var decoded = proto_keys_1.decodePublicKey(buf);
  var data = decoded.Data;

  switch (decoded.Type) {
    case "Ed25519"
    /* Ed25519 */
    :
      return exports.supportedKeys.ed25519.unmarshalEd25519PublicKey(data);

    case "RSA"
    /* RSA */
    :
    case "Secp256k1"
    /* Secp256k1 */
    :
    default:
      throw exports.keyTypeError;
  }
};
/**
 * Converts a public key object into a protobuf serialized public key
 * @param key public key.
 * @param type key type. Currently only ED25519 is supported.
 */


exports.marshalPublicKey = function (key) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "ED25519";
  if (type !== "ED25519") throw exports.keyTypeError;
  return key.bytes;
};
/**
 * Converts a protobuf serialized private key into its representative object
 * @param buf The input key bytes.
 */


exports.unmarshalPrivateKey = function (buf) {
  var decoded = proto_keys_1.decodePrivateKey(buf);
  var data = decoded.Data;

  switch (decoded.Type) {
    case "Ed25519"
    /* Ed25519 */
    :
      return exports.supportedKeys.ed25519.unmarshalEd25519PrivateKey(data);

    case "RSA"
    /* RSA */
    :
    case "Secp256k1"
    /* Secp256k1 */
    :
    default:
      throw exports.keyTypeError;
  }
}; // Converts a private key object into a protobuf serialized private key


exports.marshalPrivateKey = function (key) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "ED25519";
  if (type !== "ED25519") throw exports.keyTypeError;
  return key.bytes;
};